import QS from 'qs';
import _ from '@/setup/lodash';
import type { App } from 'vue';

function ro(o: any) {
  return window.console.log(JSON.parse(JSON.stringify(o)));
}

export default (App: App<Element>) => {
  App.config.globalProperties.$log = ro;
  App.config.globalProperties.$_ = _;
  App.config.globalProperties.$qs = QS;
};
